import { useSelector } from 'react-redux';

import { CurrentAccount } from 'types/CurrentAccount';
import { selectCurrentAccount } from 'containers/App/selectors';

export const useCurrentAccount = (): CurrentAccount | undefined =>
  useSelector(selectCurrentAccount);
